import React, { useEffect } from 'react';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Grid,
} from '@mui/material';
import { useStyles } from './style';
import copy from 'copy-to-clipboard';
import useCustomHook from './hooks';

import _ from 'lodash';
import { LoadingPage, Empty, Icons } from 'components';

import CardsServices from '../../services';
import createToast from 'components/Toast/Toast';

const ShebasList = (props) => {
  const classes = useStyles();

  const { isLoading, setIsLoading, list, setList } = useCustomHook();

  // -- HOOKS --//

  useEffect(() => {
    getItems();
  }, []);

  // -- APIS --//
  const getItems = async () => {
    try {
      setIsLoading(true);
      const params = { size: 2147483647 }; // TODO: handle pagination
      const result = await CardsServices.getPODShebas(params);
      let data = result?.result?.mainBusinessAmountSrvs;
      data = _.remove(data, function (n) {
        return n?.sheba;
      });
      setIsLoading(false);
      setList(data);
    } catch (error) {
      setIsLoading(false);

    }
  };

  // -- OTHER FUNCTIONS --//

  const copyItem = async (v) => {
    try {
      await copy(v);
      createToast('موفق', 'شماره کارت کپی شد.', 'success');
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div>
      <Grid item xs={12}>
        <TableContainer elevation={0} component={Paper} className={classes.table}>
          <Table>
            <TableHead className={classes.tableHeader}>
              <TableRow>
                <TableCell align="center" style={{ width: '1%' }}>
                  شماره
                </TableCell>
                <TableCell className={classes.tableCell} align="left">
                  عنوان حساب
                </TableCell>
                <TableCell className={classes.tableCell} align="left">
                  شماره شبا
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* List Data Map */}
              {!isLoading ? (
                !list || list.length == 0 ? (
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <Empty label="لیست شباهای پادی شما خالی است" />
                    </TableCell>
                  </TableRow>
                ) : (
                  list.map((v, k) =>
                    !v?.sheba ? null : (
                      <TableRow key={k}>
                        <TableCell align="center">{k + 1}</TableCell>
                        <TableCell>{v?.aliasName ?? v?.guildSrv?.name}</TableCell>
                        <TableCell dir="ltr" style={{ fontFamily: 'Vazir' }}>
                          <IconButton
                            className={classes.copyIcon}
                            onClick={() => copyItem(v?.sheba)}
                            size="large">
                            <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />
                          </IconButton>
                          {`IR-${v?.sheba?.toLowerCase().replaceAll('ir', '')}`}
                        </TableCell>
                      </TableRow>
                    ),
                  )
                )
              ) : null}
            </TableBody>
          </Table>
          {isLoading ? <LoadingPage /> : null}
        </TableContainer>
      </Grid>
    </div>
  );
};

export default ShebasList;
